import { useEffect, useState } from "react";
import FileAPI from "../apis/FileAPI";

const useAudios = (arr) => {
  const [audios, setAudios] = useState({});

  useEffect(() => {
    if (!arr) return;

    const pushUrlAudio = (audio) => {
      if (
        audios[audio] ||
        audio === null ||
        audio === undefined ||
        audio === ""
      )
        return;
      audios[audio] = false;
      FileAPI.getUrlAudio(audio).then((url) =>
        setAudios((state) => ({ ...state, [audio]: url }))
      );
    };

    arr.forEach((audio) => {
      pushUrlAudio(audio);
    });
  }, [arr]);

  return audios;
};

export { useAudios };
